import React from 'react'
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/system';
import Footer from "../../components/Footer"
import Header from "../../components/TopBar/index"
import "./home.scss"
const index = () => {
    /* Public nav — every entry points at a real page. */
    const pages = [
        { text: 'Features', navUrl: '/features' },
        { text: 'Pricing', navUrl: '/pricing' },
        { text: 'About us', navUrl: '/about' },
        { text: 'Contact us', navUrl: '/contact' },
    ];
    return (
        <Box>
            <Header pages={pages} isUserLoggedIn={false} />
            <Box pt={8}>
                <Outlet />
            </Box>
            <Footer />

        </Box>
    )
}

export default index